// extracted by mini-css-extract-plugin
export default {"mainContainer":"Partner_mainContainer__0oMyz","sideContainer":"Partner_sideContainer__XOn4I","sideText":"Partner_sideText__agtng","cardContainer":"Partner_cardContainer__Xj4Gp"};